import { AlertResult } from "react-migration/domains/dashboard/typings/PlanningAlertResultsResponse";
import { PlanningResultActions } from "./PlanningResultActions";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { dateSemiFullString } from "src/js/util/dates";
type PlanningResultRowProps = {
  result: AlertResult;
};

export const PlanningResultRow = ({ result }: PlanningResultRowProps) => {
  const { t } = useTranslation();

  return (
    <div
      data-testid={`planning-result-row-${result._id}`}
      className="flex flex-col p-3 border border-t-0 border-neutral-200"
    >
      <h3 className="font-semibold text-neutral-800 mb-[6px]">{result.alert_info.join(" ")}</h3>
      <div className="flex flex-wrap gap-1 mb-2">
        {result.result_item.labels.map((label) => (
          <div key={label.name} className="bg-platform-600 text-white rounded-sm px-2 py-[2px]">
            {label.name}
          </div>
        ))}
      </div>
      <p className="text-sm">{result.result_item.title}</p>
      <div className="mb-2">
        {result.result_item.address && (
          <div className="flex gap-1 text-sm">
            <span className="font-bold">{t("components.planning_record.address")}</span>
            <span>{result.result_item.address}</span>
          </div>
        )}
        {result.result_item.type && (
          <div className="flex gap-1 text-sm">
            <span className="font-bold">{t("components.planning_record.type")}</span>
            <span>{result.result_item.type}</span>
          </div>
        )}
        {result.result_item.decision && (
          <div className="flex gap-1 text-sm">
            <span className="font-bold">{t("components.planning_record.decision")}</span>
            <span>{result.result_item.decision}</span>
          </div>
        )}
        {result.result_item.applicant_name && (
          <div className="flex gap-1 text-sm">
            <span className="font-bold">{t("components.planning_record.applicant")}</span>
            <span>{result.result_item.applicant_name}</span>
          </div>
        )}
        {result.result_item.classification && (
          <div className="flex gap-1 text-sm">
            <span className="font-bold">{t("components.planning_record.classification")}</span>
            <span>{result.result_item.classification}</span>
          </div>
        )}
        {result.result_item.size && (
          <div className="flex gap-1 text-sm">
            <span className="font-bold">{t("components.planning_record.size")}</span>
            <span>{result.result_item.size}</span>
          </div>
        )}
      </div>
      <PlanningResultActions result={result} />
      <div className="flex items-baseline justify-between">
        <div className="flex gap-2 text-sm">
          <span className="text-neutral-500">{result.result_item.ref}</span>
          <span className="text-[#008000]">
            {t("dashboard.planning_alerts.application_decision", {
              decision: result.result_item.decision,
            })}
          </span>
        </div>
        <div className="text-xs text-neutral-500">
          <span className="px-2 leading-[18px] border-r border-solid border-neutral-300">
            {t("dashboard.planning_alerts.alert_sent_date", {
              date: dateSemiFullString(result.alert_date),
            })}
          </span>
          <span className="px-2 py-1">
            {t("dashboard.planning_alerts.alert_received_date", {
              date: dateSemiFullString(result.result_item.date_received),
            })}
          </span>
        </div>
      </div>
    </div>
  );
};
